/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TPublicOfferBusinessEntityAcceptRequest,
  TPublicOfferBusinessEntityAcceptModel,
  IMappers,
  TPublicOfferBusinessEntityAcceptResponse,
  TPublicOfferBusinessEntityAcceptResponseData200,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IErrorResponseSchema } from '../../../../entities/schemas/ErrorResponseSchema';

export function createPublicOfferBusinessEntityAcceptModel(
  parameters: TPublicOfferBusinessEntityAcceptRequest,
): TPublicOfferBusinessEntityAcceptModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'dailyrent',
    pathApi: '/v1/public-offer/business-entity/accept/',
    response: {
      200: {},
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IPublicOfferBusinessEntityAcceptOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TPublicOfferBusinessEntityAcceptRequest;
}

export async function fetchPublicOfferBusinessEntityAccept<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IPublicOfferBusinessEntityAcceptOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TPublicOfferBusinessEntityAcceptResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createPublicOfferBusinessEntityAcceptModel(parameters),
    config,
  )) as FetchResponse<TPublicOfferBusinessEntityAcceptResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TPublicOfferBusinessEntityAcceptResponseData200, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TPublicOfferBusinessEntityAcceptResponse>;
}
